export const CardTypeSmallIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    {...props}>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="M11.74 18.25h5.92c-.09.08-.18.15-.27.23l-4.27 3.2c-1.41 1.05-3.71 1.05-5.13 0l-4.28-3.2C2.77 17.78 2 16.23 2 15.06V7.65c0-1.22.93-2.57 2.07-3l4.98-1.87c.82-.31 2.18-.31 3 0l4.97 1.87c.95.36 1.76 1.36 2.01 2.38h-7.3c-.22 0-.42.01-.61.01-1.85.11-2.33.78-2.33 2.89v5.43c.01 2.3.6 2.89 2.95 2.89z"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.2"
      d="M8.8 11.719H22"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="M22 9.92v5.55c-.02 2.22-.63 2.77-2.94 2.77h-7.32c-2.35 0-2.94-.59-2.94-2.9V9.91c0-2.1.48-2.77 2.33-2.89.19 0 .39-.01.61-.01h7.32c2.35.01 2.94.59 2.94 2.91z"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.2"
      d="M11.32 15.76h1.33M14.75 15.76h3.27"></path>
  </svg>
);
